import { render, staticRenderFns } from "./CategorySelectionModal.vue?vue&type=template&id=66390e3a"
import script from "./CategorySelectionModal.ts?vue&type=script&lang=ts&external"
export * from "./CategorySelectionModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports